import { VanchiNo, CreateVanchiNoRequest } from '../types';

// Mock VanchiNo data based on the screenshot
const mockVanchiNos: VanchiNo[] = [
  {
    id: '1',
    nadaId: '1',
    nadaName: 'Ayyappan Ambalam',
    vanchiNameId: '1',
    vanchiName: 'AA-Vanchi-01',
    vanchiNumber: '01',
    isActive: true,
    createdAt: '2025-09-05T10:30:00Z',
    updatedAt: '2025-09-05T10:30:00Z',
    createdBy: 'Admin'
  },
  {
    id: '2',
    nadaId: '2',
    nadaName: 'Kanimula Ganapathy',
    vanchiNameId: '2',
    vanchiName: 'KG-Vanchi-01',
    vanchiNumber: '02',
    isActive: true,
    createdAt: '2025-09-05T10:30:00Z',
    updatedAt: '2025-09-05T10:30:00Z',
    createdBy: 'Admin'
  },
  {
    id: '3',
    nadaId: '3',
    nadaName: 'Malikapurathu Amman',
    vanchiNameId: '3',
    vanchiName: 'MA-Vanchi-01',
    vanchiNumber: '03',
    isActive: true,
    createdAt: '2025-09-05T10:30:00Z',
    updatedAt: '2025-09-05T10:30:00Z',
    createdBy: 'Admin'
  },
  {
    id: '4',
    nadaId: '4',
    nadaName: 'Navagraha Ambalam',
    vanchiNameId: '4',
    vanchiName: 'NA-Vanchi-01',
    vanchiNumber: '04',
    isActive: true,
    createdAt: '2025-09-05T10:30:00Z',
    updatedAt: '2025-09-05T10:30:00Z',
    createdBy: 'Admin'
  },
  {
    id: '5',
    nadaId: '5',
    nadaName: 'Pamba Ganapathy',
    vanchiNameId: '5',
    vanchiName: 'PG-Vanchi-01',
    vanchiNumber: '05',
    isActive: true,
    createdAt: '2025-09-05T10:30:00Z',
    updatedAt: '2025-09-05T10:30:00Z',
    createdBy: 'Admin'
  },
  // Additional mock data for testing
  {
    id: '6',
    nadaId: '6',
    nadaName: 'Sabarimala Sannidhanam',
    vanchiNameId: '6',
    vanchiName: 'SS-Vanchi-01',
    vanchiNumber: '06',
    isActive: true,
    createdAt: '2025-09-04T14:15:00Z',
    updatedAt: '2025-09-04T14:15:00Z',
    createdBy: 'Admin'
  },
  {
    id: '7',
    nadaId: '7',
    nadaName: 'Chottanikkara Bhagavathy',
    vanchiNameId: '7',
    vanchiName: 'CB-Vanchi-01',
    vanchiNumber: '07',
    isActive: true,
    createdAt: '2025-09-04T11:20:00Z',
    updatedAt: '2025-09-04T11:20:00Z',
    createdBy: 'Admin'
  },
  {
    id: '8',
    nadaId: '8',
    nadaName: 'Guruvayur Krishna',
    vanchiNameId: '8',
    vanchiName: 'GK-Vanchi-01',
    vanchiNumber: '08',
    isActive: true,
    createdAt: '2025-09-04T09:45:00Z',
    updatedAt: '2025-09-04T09:45:00Z',
    createdBy: 'Admin'
  },
  {
    id: '9',
    nadaId: '9',
    nadaName: 'Thiruvananthapuram Padmanabhaswamy',
    vanchiNameId: '9',
    vanchiName: 'TP-Vanchi-01',
    vanchiNumber: '09',
    isActive: true,
    createdAt: '2025-09-03T16:30:00Z',
    updatedAt: '2025-09-03T16:30:00Z',
    createdBy: 'Admin'
  },
  {
    id: '10',
    nadaId: '10',
    nadaName: 'Kodungallur Bhagavathy',
    vanchiNameId: '10',
    vanchiName: 'KB-Vanchi-01',
    vanchiNumber: '10',
    isActive: true,
    createdAt: '2025-09-03T13:15:00Z',
    updatedAt: '2025-09-03T13:15:00Z',
    createdBy: 'Admin'
  },
  {
    id: '11',
    nadaId: '11',
    nadaName: 'Vaikom Mahadeva',
    vanchiNameId: '11',
    vanchiName: 'VM-Vanchi-01',
    vanchiNumber: '11',
    isActive: true,
    createdAt: '2025-09-03T10:00:00Z',
    updatedAt: '2025-09-03T10:00:00Z',
    createdBy: 'Admin'
  },
  {
    id: '12',
    nadaId: '12',
    nadaName: 'Ettumanoor Mahadeva',
    vanchiNameId: '12',
    vanchiName: 'EM-Vanchi-01',
    vanchiNumber: '12',
    isActive: true,
    createdAt: '2025-09-02T15:45:00Z',
    updatedAt: '2025-09-02T15:45:00Z',
    createdBy: 'Admin'
  },
  {
    id: '13',
    nadaId: '13',
    nadaName: 'Thirunakkara Mahadeva',
    vanchiNameId: '13',
    vanchiName: 'TM-Vanchi-01',
    vanchiNumber: '13',
    isActive: true,
    createdAt: '2025-09-02T12:30:00Z',
    updatedAt: '2025-09-02T12:30:00Z',
    createdBy: 'Admin'
  },
  {
    id: '14',
    nadaId: '14',
    nadaName: 'Kaduthuruthy Mahadeva',
    vanchiNameId: '14',
    vanchiName: 'KM-Vanchi-01',
    vanchiNumber: '14',
    isActive: true,
    createdAt: '2025-09-02T09:15:00Z',
    updatedAt: '2025-09-02T09:15:00Z',
    createdBy: 'Admin'
  },
  {
    id: '15',
    nadaId: '15',
    nadaName: 'Vaikathashtami Mahadeva',
    vanchiNameId: '15',
    vanchiName: 'VAM-Vanchi-01',
    vanchiNumber: '15',
    isActive: true,
    createdAt: '2025-09-01T18:00:00Z',
    updatedAt: '2025-09-01T18:00:00Z',
    createdBy: 'Admin'
  }
];

export const vanchiNoService = {
  // Get all VanchiNos
  getVanchiNos: async (): Promise<VanchiNo[]> => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    return [...mockVanchiNos];
  },

  // Create a new VanchiNo
  createVanchiNo: async (data: CreateVanchiNoRequest): Promise<VanchiNo> => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // Find the nada name and vanchi name for the given IDs
    const nadaService = await import('./nadaService');
    const vanchiNameService = await import('./vanchiNameService');
    
    const [nadas, vanchiNames] = await Promise.all([
      nadaService.nadaService.getNadas(),
      vanchiNameService.vanchiNameService.getVanchiNames()
    ]);
    
    const nada = nadas.find(n => n.id === data.nadaId);
    const vanchiName = vanchiNames.find(v => v.id === data.vanchiNameId);
    
    const newVanchiNo: VanchiNo = {
      id: Date.now().toString(),
      nadaId: data.nadaId,
      nadaName: nada?.name || 'Unknown Nada',
      vanchiNameId: data.vanchiNameId,
      vanchiName: vanchiName?.vanchiName || 'Unknown Vanchi Name',
      vanchiNumber: data.vanchiNumber,
      isActive: true,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      createdBy: 'Admin' // In real app, this would come from current user context
    };

    mockVanchiNos.push(newVanchiNo);
    return newVanchiNo;
  },

  // Update an existing VanchiNo
  updateVanchiNo: async (id: string, data: Partial<CreateVanchiNoRequest>): Promise<VanchiNo> => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const index = mockVanchiNos.findIndex(vanchiNo => vanchiNo.id === id);
    if (index === -1) {
      throw new Error('VanchiNo not found');
    }

    let updatedData = { ...mockVanchiNos[index], ...data, updatedAt: new Date().toISOString() };

    // If nadaId is updated, update nadaName as well
    if (data.nadaId) {
      const nadaService = await import('./nadaService');
      const nadas = await nadaService.nadaService.getNadas();
      const nada = nadas.find(n => n.id === data.nadaId);
      updatedData.nadaName = nada?.name || 'Unknown Nada';
    }

    // If vanchiNameId is updated, update vanchiName as well
    if (data.vanchiNameId) {
      const vanchiNameService = await import('./vanchiNameService');
      const vanchiNames = await vanchiNameService.vanchiNameService.getVanchiNames();
      const vanchiName = vanchiNames.find(v => v.id === data.vanchiNameId);
      updatedData.vanchiName = vanchiName?.vanchiName || 'Unknown Vanchi Name';
    }

    mockVanchiNos[index] = updatedData;
    return updatedData;
  },

  // Delete a VanchiNo (soft delete by setting isActive to false)
  deleteVanchiNo: async (id: string): Promise<void> => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const index = mockVanchiNos.findIndex(vanchiNo => vanchiNo.id === id);
    if (index === -1) {
      throw new Error('VanchiNo not found');
    }

    mockVanchiNos[index].isActive = false;
    mockVanchiNos[index].updatedAt = new Date().toISOString();
  },

  // Toggle VanchiNo active status
  toggleVanchiNoStatus: async (id: string): Promise<VanchiNo> => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const index = mockVanchiNos.findIndex(vanchiNo => vanchiNo.id === id);
    if (index === -1) {
      throw new Error('VanchiNo not found');
    }

    mockVanchiNos[index].isActive = !mockVanchiNos[index].isActive;
    mockVanchiNos[index].updatedAt = new Date().toISOString();
    
    return mockVanchiNos[index];
  }
};
